const initialize = () => {
    function onTypeChange(typeSelected) {
        document.querySelectorAll('[data-onlyfor]').forEach((onlyEl) => {
            const onlyFor = onlyEl.dataset.onlyfor;
            if (onlyFor === typeSelected.value) {
                onlyEl.classList.remove('d-none');
            } else {
                onlyEl.classList.add('d-none');
            }
        });
    }

    const typeSelected = document.querySelector('input[name="type"]:checked');
    onTypeChange(typeSelected);

    const radios = document.querySelectorAll('input[name="type"]');
    radios.forEach((radio) => {
        radio.addEventListener('change', () => {
            onTypeChange(radio.value);
            onTypeChange(document.querySelector('input[name="type"]:checked'));
        });
    });

    const billingInfoDeleteModal = document.getElementById('billingInfoDeleteModal');
    billingInfoDeleteModal.addEventListener('show.bs.modal', (event) => {
        const button = event.relatedTarget;
        const action = button.getAttribute('data-action');
        const contactBasicData = button.getAttribute('data-contactBasicData');

        billingInfoDeleteModal.querySelector('#billingInfoDelete').setAttribute('action', action);
        billingInfoDeleteModal.querySelector('#contactBasicData').textContent = contactBasicData;
    });
};

export default initialize;
